import { Fireworks } from "fireworks-js";
const container = document.querySelector(".fireworks");
// https://fireworks.js.org/ options setting

const fireworkOptions =
    window.innerWidth < 600
        ? {
              autoresize: true,
              opacity: 0.5,
              acceleration: 1.02,
              friction: 0.9,
              gravity: 1.4,
              particles: 50,
              traceLength: 3,
              traceSpeed: 5,
              explosion: 2,
              intensity: 20,
              flickering: 50,
              lineStyle: "round",
              hue: {
                  min: 0,
                  max: 360
              },
              delay: {
                  min: 75,
                  max: 100
              },
              rocketsPoint: {
                  min: 50,
                  max: 50
              },
              lineWidth: {
                  explosion: {
                      min: 1,
                      max: 3
                  },
                  trace: {
                      min: 1,
                      max: 2
                  }
              },
              brightness: {
                  min: 50,
                  max: 80
              },
              decay: {
                  min: 0.012,
                  max: 0.016
              },
              mouse: {
                  click: false,
                  move: false,
                  max: 1
              }
          }
        : {
              autoresize: true,
              opacity: 0.5,
              acceleration: 1.02,
              friction: 0.97,
              gravity: 1.5,
              particles: 100,
              traceLength: 3,
              traceSpeed: 10,
              explosion: 5,
              intensity: 30,
              flickering: 50,
              lineStyle: "round",
              hue: {
                  min: 0,
                  max: 360
              },
              delay: {
                  min: 75,
                  max: 100
              },
              rocketsPoint: {
                  min: 50,
                  max: 50
              },
              lineWidth: {
                  explosion: {
                      min: 3.5,
                      max: 6
                  },
                  trace: {
                      min: 1,
                      max: 2
                  }
              },
              brightness: {
                  min: 50,
                  max: 80
              },
              decay: {
                  min: 0.012,
                  max: 0.016
              },
              mouse: {
                  click: false,
                  move: false,
                  max: 1
              }
          };
console.log("fireworkOptions", fireworkOptions);
const fireworks = new Fireworks(container, fireworkOptions);
fireworks.start();
